import React, { Component } from 'react'
import moment from "moment";
import { connect } from "react-redux";
import Loading from '../Loading'
import {
    TabPane,
    Grid,
    Form,
    Tab,
    Checkbox,
    Confirm,
    Popup,
    Table,
    Header,
    Label,
    Button,
    Message
} from 'semantic-ui-react'
import { boolToInt, formatCurrency } from "../../utils/commonutils";
import CollectionsDataTable from "./CollectionsDataTable";
import TierTable from './TierTable';
import { updateFinancialNoteReminderReview, saveCustomContractReview } from "../../redux/modules/payReports";
import PayCalculationExplanation from '../PayCalculationExplanation';
import GoGaNarrative from '../GoGaNarrative';
import ViewNotes from "../ViewNotes";
import HistoricalMetrics from "./HistoricalMetrics";


class PayContract extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            load: false,
            contractType: this.props.contractType,
            doctorABBR: this.props.doctorABBR,
            doctorId: this.props.doctorId,
            dentistWorkTimeType: this.props.dentistWorkTimeType,
            column: 'date',
            order: true,
            reviewDetails: false,
            checkedState: {},
            customContractReviewed: null,
            customContractComments: null,
            customContractConfirm: false,
            customContractSuccess: false,
        }

    }

    formatAmount = (value) => {
        return (value)?.toFixed(2)?.replace(/\d(?=(\d{3})+\.)/g, '$&,')
    }

    getPracticeName = (practiceDbName) => {
        const { practiceListArray = [] } = this.props;
        return practiceListArray.find(f => f.practiceDBName === practiceDbName || f.practice?.toLowerCase() === practiceDbName)?.practice || practiceDbName;
    }

    useDoctorValues = (doctor) => {
        if (doctor) {
            doctor = doctor.toUpperCase();
        }
        const productionData = this.props.billingData?.groupByDoctorByPractice;
        const doctorIndex = productionData?.findIndex(iData => iData?.ABBR?.toUpperCase() === doctor);
        const doctorValues = doctorIndex >= 0 ? productionData[doctorIndex] : null;
        return { doctorIndex, doctorValues };
    }


    getTableHeader = (contractType) => {
        if (contractType === 'GOX' || contractType === 'GOZ' || contractType === 'GOX w/HYN') {
            return (
                <thead className="table-primary">
                    <tr>
                        <td>Contract Type</td>
                        <td>Start Date</td>
                        <td>End Date</td>
                        <td>Work Time Type</td>
                        <td>Scheduled Days</td>
                        <td>Daily Rate Pay</td>
                        <td>{contractType} Pay %</td>
                        <td>ProdAdjWo %</td>
                        <td>Percentage of Billable</td>
                        <td>Worked Days</td>
                        <td>{contractType} Total</td>
                        <td>BCare</td>
                    </tr>
                </thead>
            )
        } else {
            return (
                <thead className="table-primary">
                    <tr>
                        <td>Contract Type</td>
                        <td>Start Date</td>
                        <td>End Date</td>
                        <td>Work Time Type</td>
                        <td>Scheduled Days</td>
                        <td>Worked Days</td>
                        <td>Monthly Base Work Days</td>
                        <td>Collections w/HYN Pay %</td>
                        <td>Percentage of Billable</td>
                        <td>BCare</td>
                    </tr>

                </thead>
            )
        }
    }

    getCustomRatesTable = (customRates) => {
        return (
            <div>
                <div>
                    <span className="h6 font-weight-bold">
                        Custom Rates
                    </span>
                </div>
                <table className="table table-secondary table-bordered">
                    <thead className="table-primary">
                        <tr>
                            <th>Practice</th>
                            <th>prodAdjWo</th>
                            <th>payRateOverBase</th>
                            <th>payOverBase</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.getRowsForCustomRates(customRates)}
                    </tbody>

                </table>
            </div>
        )

    }

    getRowsForCustomRates = (practiceRates) => {
        return practiceRates.map((iPractice, index) => (
            iPractice !== undefined && <tr key={index}>
                <td>{iPractice.practiceName}</td>
                <td>{iPractice.prodAdjWo}</td>
                <td>{iPractice.payRateOverBase}</td>
                <td>{iPractice.payOverBase}</td>
            </tr>
        ))

    }

    onChangeCheckbox = (value, reminderId, doctorIndex) => {
        this.setState(prevState => ({
            checkedState: {
                ...prevState.checkedState,
                [reminderId]: value
            },
            reviewDetails: { value: boolToInt(value), reminderId, doctorIndex }
        }))
    }

    handleConfirm = () => {
        const { dispatch } = this.props;
        const { reviewDetails, doctorId } = this.state;

        dispatch(updateFinancialNoteReminderReview({ ...reviewDetails, doctorId }))
        this.setState({ reviewDetails: false })
    }
    handleCancel = () => {
        this.setState({ reviewDetails: false })
    }

    initCustomContractState = () => {
        const { doctorValues } = this.useDoctorValues(this.state.doctorABBR);
        const customContract = doctorValues?.doctorPayVariables?.someValues?.Doctors?.[0]?.doctorCustomContracts?.[0];
        this.setState({
            customContractReviewed: !!customContract?.reviewed,
        });
    }

    handleCustomContractSave = () => {
        this.setState({ customContractConfirm: true });
    }

    handleCustomContractConfirm = () => {
        const { dispatch } = this.props;
        const { doctorId, startDate, customContractReviewed, customContractComments } = this.state;
        const { doctorIndex, doctorValues } = this.useDoctorValues(this.state.doctorABBR);
        const customContract = doctorValues?.doctorPayVariables?.someValues?.Doctors?.[0]?.doctorCustomContracts?.[0];
        const payMonth = moment(startDate).format('MMMM YYYY');

        const reviewed = customContractReviewed !== null ? customContractReviewed : !!customContract?.reviewed;
        const comments = customContractComments !== null ? customContractComments : (customContract?.comments || '');

        dispatch(saveCustomContractReview({
            doctorId,
            payMonth,
            reviewed: boolToInt(reviewed),
            comments,
            doctorIndex,
        })).then(() => {
            this.setState({ customContractSuccess: true, customContractError: false });
            setTimeout(() => this.setState({ customContractSuccess: false }), 3000);
        }).catch(() => {
            this.setState({ customContractError: true, customContractSuccess: false });
            setTimeout(() => this.setState({ customContractError: false }), 3000);
        });
        this.setState({ customContractConfirm: false, customContractReviewed: null, customContractComments: null });
    }

    handleCustomContractCancel = () => {
        this.setState({ customContractConfirm: false });
    }

    getTableData = (contractType, startDate, dentistWorkTimeType, numberOfScheduledDays, numberOfWorkedDays, bCare, dailyRatePay, percentageOfBillable, payOverBase, prodAdjWo, GoxNonBillableCare, monthlyBaseWorkDays) => {
        if (contractType === 'GOX' || contractType === 'GOZ' || contractType === 'GOX w/HYN') {
            return (
                <tr>
                    <td>{contractType}</td>
                    <td>{moment(startDate).format('MMMM YYYY')}</td>
                    <td>{moment(startDate).add(1, 'months').format('MMMM YYYY')}</td>
                    <td>{dentistWorkTimeType}</td>
                    <td>{numberOfScheduledDays}</td>
                    <td>${dailyRatePay}</td>
                    <td>{payOverBase} %</td>
                    <td>{prodAdjWo} %</td>
                    <td>{percentageOfBillable?.toFixed(2)} %</td>
                    <td>{numberOfWorkedDays}</td>
                    <td>${this.formatAmount(GoxNonBillableCare)}</td>
                    <td>${this.formatAmount(bCare)}</td>
                </tr>
            )
        } else {
            return (
                <tr>
                    <td>{contractType}</td>
                    <td>{moment(startDate).format('MMMM YYYY')}</td>
                    <td>{moment(startDate).add(1, 'months').format('MMMM YYYY')}</td>
                    <td>{dentistWorkTimeType}</td>
                    <td>{numberOfScheduledDays}</td>
                    <td>{numberOfWorkedDays}</td>
                    <td>{monthlyBaseWorkDays}</td>
                    <td>{payOverBase} %</td>
                    <td>{percentageOfBillable?.toFixed(2)} %</td>
                    <td>${this.formatAmount(bCare)}</td>
                </tr>
            )
        }
    }

    render() {
        const { load, contractType, reviewDetails } = this.state
        const { timeOffRequestData, GoxNonBillableCare, billingData } = this.props
        const { doctorIndex, doctorValues } = this.useDoctorValues(this.state.doctorABBR)
        const supportUser = doctorValues.doctorPayVariables?.someValues?.Doctors[0].supportUser
        const financialRemindersData = doctorValues?.doctorPayVariables?.someValues?.Doctors[0]?.doctorFinancialNoteReminders;

        const customProviderRates = Object.keys(doctorValues.data)
            .flatMap(iPracticeKey => {
                const iPractice = doctorValues.data[iPracticeKey];
                const practiceName = iPractice.practiceInfo[0].practice;

                if (iPractice.customProviderRates.length > 1) {
                    return { ...iPractice.customProviderRates[0], practiceName };
                }

                return [];
            });

        const goGaBreakdown = ['GO GA', 'GO GA w/HYN'].includes(contractType)
            ? Object.keys(doctorValues.data)
                .map(iPracticeKey => {
                    const iPractice = doctorValues.data[iPracticeKey];
                    return iPractice.goGaSummary
                        ? { ...iPractice.goGaSummary, financialNotes: iPractice.financialNotes || 0, practiceTotalPay: iPractice.practiceTotalPay || 0 }
                        : null;
                })
                .filter(Boolean)
            : [];

        const hasCustomRates = customProviderRates.find((rate) => rate !== undefined);
        const { bCare, price, numberOfScheduledDays, numberOfWorkedDays, prodAdjWo } = doctorValues
        const { payOverBase, dailyRatePay } = doctorValues.doctorPayVariables;
        const dailyRateBasedPay = dailyRatePay * numberOfWorkedDays * payOverBase * 0.01
        const bCareBasedPay = bCare * payOverBase / 100;
        const rawMonthlyBaseProduction = doctorValues.doctorPayVariables.monthlyBaseProduction
        const rawMonthlyBasePay = doctorValues.doctorPayVariables.monthlyBasePay
        const monthlyBaseWorkDays = doctorValues.doctorPayVariables.monthlyBaseWorkDays;


        let monthlyBasePay, monthlyBaseProduction
        if (contractType === 'Sum Of' || contractType === 'Sum Of w/HYN') {
            if (monthlyBaseWorkDays > numberOfScheduledDays) {
                monthlyBasePay = rawMonthlyBasePay * (numberOfScheduledDays / monthlyBaseWorkDays)
                monthlyBaseProduction = rawMonthlyBaseProduction * (numberOfScheduledDays / monthlyBaseWorkDays)
            }

            if (monthlyBaseWorkDays <= numberOfScheduledDays) {
                monthlyBasePay = rawMonthlyBasePay
                monthlyBaseProduction = rawMonthlyBaseProduction
            }

        }

        const doctorName = doctorValues?.doctorPayVariables ? doctorValues.doctorPayVariables.firstName + ' ' + doctorValues.doctorPayVariables.lastName : '--'
        const FTODays = timeOffRequestData ? timeOffRequestData?.filter(row => row.requestType === 'forced' && row.doctorName === doctorName).length : 0;
        const RTODays = timeOffRequestData ? timeOffRequestData?.filter(row => row.requestType === 'requested' && row.doctorName === doctorName).length : 0;

        let collectionsPay, earningsPay;
        if (contractType === 'Collections') {
            collectionsPay = billingData?.collectionGroupByDentistByPractice[this.state.doctorABBR]?.price;
            monthlyBasePay = numberOfWorkedDays * dailyRatePay;
            earningsPay = Math.max(monthlyBasePay, (collectionsPay * (payOverBase / 100)));
        }

        const collectionsPracticeObject = billingData?.collectionGroupByDentistByPractice?.[this.state.doctorABBR?.toUpperCase()]?.data || {};
        const collectionsList = Object.keys(collectionsPracticeObject).map(iPracticeKey => {
            const practiceCollectionsObject = collectionsPracticeObject[iPracticeKey]?.data || {};
            return Object.keys(practiceCollectionsObject).map(iDateKey => {
                const dailyCollections = practiceCollectionsObject[iDateKey] || [];
                return [...dailyCollections];
            });
        });

        const providerPracData = billingData?.groupByDoctorByPractice?.find(iRow => (iRow?.ABBR)?.toUpperCase() === (this.state.doctorABBR)?.toUpperCase()) || {}
        const isProviderOnTierBonus = providerPracData?.isProviderOnTierBonus || false;
        const providerTierArray = providerPracData?.data ? Object.keys(providerPracData.data)
            .sort((a, b) => a < b ? -1 : 1)
            .map(iPracticeKey => providerPracData.data[iPracticeKey])
            .map(iPractice => {
                const { tierBonusPayRecords } = iPractice;
                return ({ tierBonusPayRecords })
            }) : [];

        const tierDataList = providerTierArray.map(iRow => iRow.tierBonusPayRecords)
        const ReminderContent = (
            <div>
                <div className="content">
                    {
                        !financialRemindersData.length &&
                        <Form.Field className={'mb20'}>No Financial Notes Reminders assigned to this
                            Provider!</Form.Field>
                    }
                    {
                        financialRemindersData && financialRemindersData.map(item => {
                            const isChecked = this.state.checkedState.hasOwnProperty(item.financialNoteReminderId)
                                ? this.state.checkedState[item.financialNoteReminderId]
                                : !!item.reviewed;

                            return (
                                <Grid.Column width={4} key={item.id} className="mb20">
                                    <Form.Field>
                                        <Checkbox
                                            onChange={(e, { checked }) => this.onChangeCheckbox(checked, item.financialNoteReminderId, doctorIndex)}
                                            checked={isChecked}
                                            className="ml-5"
                                            label={item?.financialNoteReminder?.title}
                                        />
                                    </Form.Field>
                                </Grid.Column>
                            )
                        })
                    }

                    <Form.Field><b>Provider Support : {supportUser?.firstname} {supportUser?.lastname}</b></Form.Field>
                </div>
            </div>
        )
        const PayContractContent = (<div>
            {load && <Loading />}
            <div className="content">
                <div>
                    <span className="h4 font-weight-bold primaryColor">
                        {doctorName}
                    </span>
                </div>
                <div>
                    <span className="h4 font-weight-bold">
                        {moment(this.state.startDate).format('MMMM YYYY')}
                    </span>

                </div>
                <div>
                    <span className="h6 font-weight-bold">
                        {customProviderRates && customProviderRates.length > 0 ? "Has Custom Rates" : ""}
                    </span>

                </div>
                <div className="table">
                    <table className="table table-primary table-bordered">
                        {this.getTableHeader(contractType)}
                        <tbody>
                            {this.getTableData(contractType, this.state.startDate, this.state.dentistWorkTimeType, numberOfScheduledDays, numberOfWorkedDays, bCare, dailyRatePay, doctorValues.percentageOfBillable, payOverBase, prodAdjWo, GoxNonBillableCare, monthlyBaseWorkDays)}
                        </tbody>
                    </table>


                    {(contractType === 'Sum Of' || contractType === 'Sum Of w/HYN') &&
                        <table className="table table-secondary table-bordered">
                            <thead className="table-primary">
                                <tr>
                                    <th>Time Off Requested</th>
                                    <th>Time Off Forced</th>
                                    <th>Base Work Days</th>
                                    <th>Monthly Base Production</th>
                                    <th>Monthly Base Pay</th>
                                    <th>ADJWO %</th>
                                    <th>Pay Over Base</th>
                                </tr>

                            </thead>
                            <tbody>
                                <tr>
                                    <td>{RTODays}</td>
                                    <td>{FTODays}</td>
                                    <td>{monthlyBaseWorkDays}</td>
                                    <td>{rawMonthlyBaseProduction}({monthlyBaseProduction})</td>
                                    <td>{rawMonthlyBasePay}({monthlyBasePay})</td>
                                    <td>{prodAdjWo}</td>
                                    <td>{payOverBase}</td>
                                </tr>
                            </tbody>
                        </table>}
                    {(contractType === 'Greater Of' || contractType === 'Collections' || contractType === 'Greater Of w/HYN') &&
                        <table className="table table-secondary table-bordered">
                            <thead className="table-primary">
                                <tr>
                                    <td>{(contractType === 'Greater Of' || contractType === 'Greater Of w/HYN') ? 'Care/Production' : 'Care'}</td>
                                    <td>Write Offs</td>
                                    <td>Adjustments</td>
                                    <td>Daily Rate</td>
                                    <td>ADJWO %</td>
                                    <td>{(contractType === 'Greater Of' || contractType === 'Greater Of w/HYN') ? 'Pay Rate(Pay Over Base)' : 'Collections Rate'}</td>
                                    {(contractType === 'Greater Of' || contractType === 'Greater Of w/HYN') &&
                                        <td>bCare Based Pay</td>}
                                    {(contractType === 'Greater Of' || contractType === 'Greater Of w/HYN') &&
                                        <td>Daily Rate Based Pay</td>}
                                    {contractType === "Collections" && <td>Collections</td>}
                                    {contractType === "Collections" && <td>Monthly Base Pay</td>}
                                    {contractType === "Collections" && <td>Total Pay</td>}
                                </tr>


                            </thead>
                            <tbody>
                                <tr>
                                    <td>${this.formatAmount(price)}</td>
                                    <td>${this.formatAmount(doctorValues.writeOffPrice)}</td>
                                    <td>${this.formatAmount(doctorValues.adjustmentPrice)}</td>
                                    <td>${this.formatAmount(dailyRatePay)}</td>
                                    <td>{prodAdjWo}</td>
                                    <td>{payOverBase}</td>
                                    {(contractType === 'Greater Of' || contractType === 'Greater Of w/HYN') &&
                                        <td>{this.formatAmount(bCareBasedPay)}</td>}
                                    {(contractType === 'Greater Of' || contractType === 'Greater Of w/HYN') &&
                                        <td>{this.formatAmount(dailyRateBasedPay)}</td>}
                                    {contractType === "Collections" &&
                                        <td>{this.formatAmount(collectionsPay)}</td>}
                                    {contractType === "Collections" &&
                                        <td>{this.formatAmount(monthlyBasePay)}</td>}
                                    {contractType === "Collections" &&
                                        <td>{this.formatAmount(earningsPay)}</td>}
                                </tr>
                            </tbody>
                        </table>
                    }
                    {['GO GA', 'GO GA w/HYN'].includes(contractType) && goGaBreakdown.map((summary, index) => (
                        <div key={index} className="ui segment">
                            <GoGaNarrative narrative={summary.narrative} practiceName={summary.practiceName} />
                        </div>
                    ))}
                    {hasCustomRates !== undefined && customProviderRates.length > 0 && this.getCustomRatesTable(customProviderRates)}
                </div>
            </div>
        </div>)

        const AjdWoContent = () => {
            const doctor = this.props.billingData?.doctorList?.find(d => d.doctorId === doctorValues.doctorId);
            return <div>
                <p>List: <b>{doctor?.codeListId ?? '-'}</b></p>
                <p>Date: <b>{doctor?.adjWriteOffType ?? '-'}</b></p>
            </div>
        }

        const WorkHistoryContent = () => {
            const productionData = this.props.billingData?.groupByDoctorByPractice;
            const workHistory = productionData?.[doctorIndex]?.workHistory;
            return   <table className="table table-striped table-hover my-0">
                <thead>
                <tr>
                    <th className={`FreezeTable-first-child `} >
                        <div>
                            Practice
                        </div>
                    </th>
                    <th className={`FreezeTable-first-child `} >
                        <div>
                            Days Worked
                        </div>
                    </th>
                    <th className={`FreezeTable-first-child `}>
                        <div>
                            First Work Date
                        </div>
                    </th>
                    <th className={`FreezeTable-first-child `} >
                        <div>
                            Last Work Date
                        </div>
                    </th>
                    <th className={`FreezeTable-first-child `} >
                        <div>
                            Next Work Date
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody>

                {
                    workHistory&&workHistory.length <= 0?"No Schedule History": (workHistory&&workHistory.map(data=>{
                        return <tr>
                            <td> {data.practice}</td>
                            <td> {data.days}</td>
                            <td> {moment(data.firstWorkDay).format('YYYY-MM-DD')}</td>
                            <td> {data.lastWorkDay ? moment(data.lastWorkDay).format('YYYY-MM-DD'):'No Schedule'}</td><
                            td> {data.nextWorkDay ? moment(data.nextWorkDay).format('YYYY-MM-DD'):'No Schedule'}</td></tr>
                    }))

                }

                </tbody>
            </table>
        }

        const McoDataContent = () => {
            const productionData = this.props.billingData?.groupByDoctorByPractice;
             const McoData = productionData?.[doctorIndex]?.McoData;
            // group data by practice
            const grouped = McoData.reduce((acc, item) => {
                acc[item.practice] = acc[item.practice] || [];
                acc[item.practice].push(item);
                return acc;
            }, {});

            const fields = [
                { name: 'date', label: 'Date Credentialed', type: 'date' },
                { name: 'application', label: 'Application Sent', type: 'date' },
                { name: 'ATPI', label: 'TPI Sent', type: 'date' },
                { name: 'recredentialBy', label: 'RecredentialBy', type: 'date' },
                { name: 'recredentialApplicationSent', label: 'ReCred App Sent', type: 'date' },
                { name: 'followUp', label: 'Follow Up Date', type: 'date' },
                { name: 'lastNote', label: 'Last Note Date', type: 'date' }
            ];

            return (
                <div>
                    {Object.entries(grouped).map(([practice, carriers]) => (
                        <div key={practice} className={'table-responsive'}>
                            <Header as="h3" dividing>
                                {practice.toUpperCase()}
                            </Header>

                            <Table className={'table table-striped table-hover my-0'}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Status</Table.HeaderCell>
                                        <Table.HeaderCell>Carrier</Table.HeaderCell>
                                        <Table.HeaderCell>Date Credentialed</Table.HeaderCell>
                                        <Table.HeaderCell>Application Sent</Table.HeaderCell>
                                        <Table.HeaderCell>TPI Sent</Table.HeaderCell>
                                        <Table.HeaderCell>RecredentialBy</Table.HeaderCell>
                                        <Table.HeaderCell>ReCred App Sent</Table.HeaderCell>
                                        <Table.HeaderCell>Follow Up Date</Table.HeaderCell>
                                        <Table.HeaderCell>Last Note Date</Table.HeaderCell>
                                        <Table.HeaderCell>Blocked</Table.HeaderCell>
                                        <Table.HeaderCell>Ignore</Table.HeaderCell>
                                        <Table.HeaderCell>Notes</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {carriers.map((carrier) => {
                                        const hasDate = carrier.date && moment(carrier.date).isValid();
                                        let prevNotes;
                                        try {
                                            if (Array.isArray(JSON.parse(carrier.notes))) {
                                                prevNotes = JSON.parse(carrier.notes);
                                                carrier.prevNotes = prevNotes ? prevNotes : [];
                                                carrier.notes = prevNotes[prevNotes.length - 1]?.note ?? null;
                                            }
                                            if (!carrier.prevNotes) {
                                                carrier.prevNotes = [];
                                            }
                                        } catch (e) {
                                            if (!carrier.prevNotes) {
                                                carrier.prevNotes = [];
                                            }
                                        }

                                        return (
                                            <Table.Row key={carrier.id}>
                                                {/* Status */}
                                                <Table.Cell collapsing>
                                                    <Popup
                                                        trigger={
                                                            <Label
                                                                circular
                                                                color={
                                                                    carrier.ignore
                                                                        ? "yellow"
                                                                        : hasDate
                                                                            ? "green"
                                                                            : "red"
                                                                }
                                                                empty
                                                            />
                                                        }
                                                        content={
                                                            hasDate
                                                                ? `${carrier.type} Date`
                                                                : `${carrier.type} Date Missing`
                                                        }
                                                        position="bottom center"
                                                    />
                                                </Table.Cell>

                                                <Table.Cell>{carrier.type}</Table.Cell>

                                                {fields.map((field) => (
                                                    <Table.Cell key={`${carrier.type}_${field.name}`}>
                                                        {carrier[field.name]
                                                            ? moment(carrier[field.name]).format("DD-MMM-YYYY")
                                                            : "-"}
                                                    </Table.Cell>
                                                ))}

                                                <Table.Cell>{carrier.blocked ? "Yes" : "No"}</Table.Cell>
                                                <Table.Cell>{carrier.ignore ? "Yes" : "No"}</Table.Cell>
                                                <Table.Cell>
                                                    {carrier.notes || "-"}
                                                    {carrier.prevNotes?.length > 0 && (
                                                        <span className="float-right">
                                                        <ViewNotes prevNotes={carrier.prevNotes} />
                                                    </span>
                                                    )}
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    })}
                                </Table.Body>
                            </Table>
                        </div>
                    ))}
                </div>
            );
        }

        const PpoDataContent = () => {
            const productionData = this.props.billingData?.groupByDoctorByPractice;
            const PpoData = productionData?.[doctorIndex]?.PpoData;
            // group data by practice
            const grouped = PpoData.reduce((acc, item) => {
                acc[item.practice] = acc[item.practice] || [];
                acc[item.practice].push(item);
                return acc;
            }, {});

            const fields = [
                {name: "date", label: "Date", type: "date"},
                {name: "applicationSent", label: "Application Sent", type: "date"},
                {name: "followUp", label: "Follow Up Date", type: "date"},
                {name: "expiry", label: "Expiry", type: "date"},
                {name: "recredentialApplicationSent", label: "ReCred App Sent", type: "date"}
            ];
            
            return (
                <div>
                    {Object.entries(grouped).map(([practice, carriers]) => (
                        <div key={practice} className={'table-responsive'}>
                            <Header as="h3" dividing>
                                {practice.toUpperCase()}
                            </Header>

                            <Table className={'table table-striped table-hover my-0'}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Status</Table.HeaderCell>
                                        <Table.HeaderCell>Carrier</Table.HeaderCell>
                                        <Table.HeaderCell>Date Credentialed</Table.HeaderCell>
                                        <Table.HeaderCell>Application Sent</Table.HeaderCell>
                                        <Table.HeaderCell>Follow up</Table.HeaderCell>
                                        <Table.HeaderCell>ReCred By</Table.HeaderCell>
                                        <Table.HeaderCell>ReCred App Sent</Table.HeaderCell>
                                        <Table.HeaderCell>Blocked</Table.HeaderCell>
                                        <Table.HeaderCell>Ignore</Table.HeaderCell>
                                        <Table.HeaderCell>Last Note Date</Table.HeaderCell>
                                        <Table.HeaderCell>Notes</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {carriers.map((carrier) => {
                                        const hasDate = carrier.date && moment(carrier.date).isValid();
                                        let prevNotes;
                                        try {
                                            if (Array.isArray(JSON.parse(carrier.notes))) {
                                                prevNotes = JSON.parse(carrier.notes);
                                                carrier.prevNotes = prevNotes ? prevNotes : [];
                                                carrier.notes = prevNotes[prevNotes.length - 1]?.note ?? null;
                                            }
                                            if (!carrier.prevNotes) {
                                                carrier.prevNotes = [];
                                            }
                                        } catch (e) {
                                            if (!carrier.prevNotes) {
                                                carrier.prevNotes = [];
                                            }
                                        }

                                        return (
                                            <Table.Row key={carrier.id}>
                                                {/* Status */}
                                                <Table.Cell collapsing>
                                                    <Popup
                                                        trigger={
                                                            <Label
                                                                circular
                                                                color={
                                                                    carrier.ignore
                                                                        ? "yellow"
                                                                        : hasDate
                                                                            ? "green"
                                                                            : "red"
                                                                }
                                                                empty
                                                            />
                                                        }
                                                        content={
                                                            hasDate
                                                                ? `${carrier.type} Date`
                                                                : `${carrier.type} Date Missing`
                                                        }
                                                        position="bottom center"
                                                    />
                                                </Table.Cell>

                                                <Table.Cell>{carrier.type}</Table.Cell>

                                                {fields.map((field) => (
                                                    <Table.Cell key={`${carrier.type}_${field.name}`}>
                                                        {carrier[field.name]
                                                            ? moment(carrier[field.name]).format("DD-MMM-YYYY")
                                                            : "-"}
                                                    </Table.Cell>
                                                ))}

                                                <Table.Cell>{carrier.blocked ? "Yes" : "No"}</Table.Cell>
                                                <Table.Cell>{carrier.ignore ? "Yes" : "No"}</Table.Cell>
                                                <Table.Cell>{carrier.lastNoteDate || "-"}</Table.Cell>
                                                <Table.Cell>
                                                    {carrier.notes || "-"}
                                                    {carrier.prevNotes?.length > 0 && (
                                                        <span className="float-right">
                                                        <ViewNotes prevNotes={carrier.prevNotes} />
                                                    </span>
                                                    )}
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    })}
                                </Table.Body>
                            </Table>
                        </div>
                    ))}
                </div>
            );
        }


        const panes = [
            {
                menuItem: { key: 'contract-details', icon: 'user md', content: 'Contract Details' },
                render: () => <TabPane>{PayContractContent}</TabPane>,
            },
            {
                menuItem: { key: 'pay-explanation', icon: 'calculator', content: 'Pay Explanation' },
                render: () => <TabPane>
                    <PayCalculationExplanation doctorABBR={this.state.doctorABBR} billingData={this.props.billingData} />
                </TabPane>,
            },
            {
                menuItem: (
                    { key: 'collection-records', icon: 'list', content: 'Collections Records' }
                ),
                render: () => <TabPane>
                    <CollectionsDataTable collectionsList={collectionsList} formatCurrency={formatCurrency} getPracticeName={this.getPracticeName} />
                </TabPane>,
            },
            {
                menuItem: (
                    { key: 'tier-records', icon: 'list', content: 'Tier Records' }
                ),
                render: () => <TabPane>
                    <TierTable tierData={tierDataList} formatCurrency={formatCurrency}
                        isProviderOnTierBonus={isProviderOnTierBonus} />
                </TabPane>,
            },
            {
                menuItem: (
                    { key: 'financial-notes-reminders', icon: 'list', content: 'Financial Notes Reminders' }
                ),
                render: () => <TabPane>
                    {ReminderContent}
                </TabPane>,
            },
            {
                menuItem: (
                    { key: 'adj-wo', icon: 'cog', content: 'Adj/WO' }
                ),
                render: () => <TabPane>
                    <AjdWoContent/>
                </TabPane>,
            },{
                menuItem: (
                    { key: 'work-history', icon: 'cog', content: 'Work History' }
                ),
                render: () => <TabPane>
                    <WorkHistoryContent/>
                </TabPane>,
            },
            {
                menuItem: (
                    { key: 'ppo-details', icon: 'cog', content: 'PPO Details' }
                ),
                render: () => <TabPane>
                    <PpoDataContent/>
                </TabPane>,
            },
            {
                menuItem: (
                    { key: 'mco-details', icon: 'cog', content: 'MCO Details' }
                ),
                render: () => <TabPane>
                    <McoDataContent/>
                </TabPane>,
            },
            {
                menuItem: (
                    { key: 'historical-metrics', icon: 'history', content: 'Historical Metrics' }
                ),
                render: () => <TabPane>
                    <HistoricalMetrics doctorABBR={this.state.doctorABBR}/>
                </TabPane>,
            },
        ]

        if (doctorValues?.customContract) {
            const doctorData = doctorValues?.doctorPayVariables?.someValues?.Doctors?.[0];
            const customContractData = doctorData?.doctorCustomContracts?.[0];
            const reviewed = this.state.customContractReviewed !== null
                ? this.state.customContractReviewed
                : !!customContractData?.reviewed;
            const contractDetails = doctorData?.customContractDetails || '';
            const comments = this.state.customContractComments !== null
                ? this.state.customContractComments
                : (customContractData?.comments || '');
            const fileLink = doctorData?.customContractFileLink || '';

            panes.push({
                menuItem: { key: 'custom-contract', icon: 'file alternate', content: 'Custom Contract' },
                render: () => (
                    <TabPane>
                        {this.state.customContractSuccess && (
                            <Message success>
                                <Message.Header>Saved</Message.Header>
                                <p>Custom contract review saved successfully.</p>
                            </Message>
                        )}
                        {this.state.customContractError && (
                            <Message negative>
                                <Message.Header>Error</Message.Header>
                                <p>Failed to save custom contract review.</p>
                            </Message>
                        )}
                        <Grid columns={2} divided>
                            <Grid.Column>
                                <Form>
                                    <Form.Field>
                                        <Checkbox
                                            label="Reviewed"
                                            checked={reviewed}
                                            onChange={(e, { checked }) => this.setState({ customContractReviewed: checked })}
                                        />
                                    </Form.Field>
                                    <Form.TextArea
                                        label="Monthly Comments"
                                        value={comments}
                                        onChange={(e, { value }) => this.setState({ customContractComments: value })}
                                        placeholder="Comments..."
                                    />
                                    <Button primary onClick={this.handleCustomContractSave}>Save</Button>
                                </Form>
                            </Grid.Column>
                            <Grid.Column>
                                <Form.Field>
                                    <label><b>Contract Details</b></label>
                                    <p>{contractDetails || '-'}</p>
                                </Form.Field>
                                <Form.Field className='mt20'>
                                    <label><b>File Link</b></label>
                                    <p>{fileLink || '-'}</p>
                                </Form.Field>
                            </Grid.Column>
                        </Grid>
                    </TabPane>
                ),
            });
        }

        const PayContractTabs = <Tab panes={panes} />
        return (
            <div>
                {PayContractTabs}
                {reviewDetails && <Confirm
                    open={true}
                    content='Are you sure you have reviewed it?'
                    onCancel={this.handleCancel}
                    onConfirm={this.handleConfirm}
                />}
                {this.state.customContractConfirm && <Confirm
                    open={true}
                    content='Are you sure you want to save the custom contract review?'
                    onCancel={this.handleCustomContractCancel}
                    onConfirm={this.handleCustomContractConfirm}
                />}
            </div>
        );
    }
}

export default connect(
    state => ({
        user: state.get('auth').get('user')
    }))(PayContract);
